'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var WalkMe = exports.WalkMe = function () {
  function WalkMe() {
    _classCallCheck(this, WalkMe);
  }

  _createClass(WalkMe, null, [{
    key: 'inject',
    value: function inject(environmentURL, api_key, walkMeVariables) {
      var walkme = document.createElement('script');
      walkme.type = 'text/javascript';
      walkme.async = true;
      walkme.src = 'https://cdn.walkme.com/users/' + api_key + environmentURL + '/walkme_' + api_key + '_https.js';
      var s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(walkme, s);
      window._walkmeConfig = {
        smartLoad: true
      };
      window.walkMeVariables = walkMeVariables;
    }
  }, {
    key: 'initialize',
    value: function initialize(_ref) {
      var environment = _ref.environment,
          api_key = _ref.api_key,
          walkMeVariables = _ref.walkMeVariables;

      if (environment === 'production') {
        WalkMe.inject('', api_key, walkMeVariables);
      } else {
        WalkMe.inject('/test', api_key, walkMeVariables);
      }
    }
  }]);

  return WalkMe;
}();